import { useState, useEffect } from 'react';

// Bump the version when you ship something new and want to re-show the banner
const WHATS_NEW = {
  version: '2026-05-14b',
  title: "What's New in CareGuard",
  items: [
    { icon: 'fa-newspaper', label: 'NEW: Daily Alzheimer\'s & dementia news with AI takeaways for caregivers.' },
    { icon: 'fa-people-group', label: 'Caregiver Directory — connect with caregivers in your county/state.' },
    { icon: 'fa-quote-left', label: 'Daily inspirational quote on your dashboard.' },
    { icon: 'fa-chart-pie', label: 'Admin stat cards are now clickable — jump straight to the data.' },
  ],
};

const STORAGE_KEY = 'careguard:whats-new-dismissed';

const WhatsNewBanner = ({ user }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    const dismissedVersion = localStorage.getItem(STORAGE_KEY);
    if (dismissedVersion !== WHATS_NEW.version) {
      setOpen(true);
    }
  }, [user]);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, WHATS_NEW.version);
    setOpen(false);
  };

  if (!open || !user) return null;

  return (
    <div className="whats-new-banner" data-testid="whats-new-banner">
      <div className="whats-new-content">
        <div className="whats-new-header">
          <i className="fa-solid fa-sparkles"></i>
          <h4>{WHATS_NEW.title}</h4>
          <button
            className="whats-new-close"
            data-testid="whats-new-dismiss"
            onClick={dismiss}
            aria-label="Dismiss"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <ul>
          {WHATS_NEW.items.map((item, i) => (
            <li key={i}><i className={`fa-solid ${item.icon}`} /> {item.label}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default WhatsNewBanner;
